import React from 'react'
import ModalWrapper from 'components/modals/ModalWrapper'
import _ from 'lodash'
import PropTypes from 'prop-types'
import InputLabel from '@material-ui/core/InputLabel'
import InputAdornment from '@material-ui/core/InputAdornment'
import Input from '@material-ui/core/Input'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Switch from '@material-ui/core/Switch'
import TaxeSelectionComponent from 'components/taxes/TaxeSelectionComponent'
import { withStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import Grid from '@material-ui/core/Grid'
import CategorySelectionComponent from 'components/category/CategorySelectionComponent'
import ColorPickerComponent from 'routes/Admin/components/CommonComponents/ColorPickerComponent'
const styles = theme => ({
  formControl: {
    // margin : `0 ${theme.spacing.unit}px`
  },
  group: {
    margin: `${theme.spacing.unit}px 0`
  }
})

class ProductModal extends React.Component {
  static propTypes = {
    classes: PropTypes.object,
    product: PropTypes.object,
    categories: PropTypes.array,
    taxes: PropTypes.array,
    updateProduct: PropTypes.func,
    createProduct: PropTypes.func,
    productNames: PropTypes.array,
    defaultCategory: PropTypes.object,
    hideModal: PropTypes.func
  }
  static defaultProps = {
    productNames: []
  }
  state = {
    product: {
      name: '',
      color: '',
      category: void 0,
      tva: void 0,
      price: '0.00',
      stockManagement: false
    },
    isValid: false,
    errors: {},
    helpers: {}
  }
  updateState = nextState => {
    const { product } = nextState
    const productProps = this.props.product
    let isValid = true
    let helpers = {}
    if (
      !productProps &&
      this.props.productNames.includes(_.lowerCase(product.name))
    ) {
      helpers.name = 'Une autre produit existe déjà avec ce nom'
    }
    if (productProps && isValid) {
      isValid = !_.isEqual(productProps, product)
    }
    this.setState({ ...nextState, isValid, helpers })
  }
  handleChange = name => (e, val) => {
    const isChecker = e.target.value === 'checker'
    let value = isChecker ? e.target.checked : val || e.target.value
    this.updateState({
      ...this.state,
      product: { ...this.state.product, [name]: value }
    })
  }
  handleCategoryChange = category => {
    this.updateState({
      ...this.state,
      product: {
        ...this.state.product,
        color: category.color,
        tva: category.tva,
        category: category
      }
    })
  }
  handleTvaChange = tva => {
    this.updateState({
      ...this.state,
      product: { ...this.state.product, tva: tva }
    })
  }
  handleColorSelection = name => color => {
    this.updateState({
      ...this.state,
      product: { ...this.state.product, [name]: color }
    })
  }

  handleOnCreate = () => {
    const { product } = this.state
    this.props.createProduct(product)
  }
  handleOnUpdate = () => {
    const { product } = this.state
    this.props.updateProduct(this.props.product, product)
  }

  colorPicker = classes => {
    const { product } = this.state
    return (
      <ColorPickerComponent
        className={classes.colorControl}
        colorValidate={this.handleColorSelection('color')}
        color={product.color}
      />
    )
  }
  componentDidMount() {
    const { product, defaultCategory, categories } = this.props
    let nextState = { ...this.state }
    if (product) {
      nextState = { product: { ...product } }
    }
    if (!product && defaultCategory) {
      nextState.product.category = defaultCategory
      nextState.product.tva = defaultCategory.tva
      nextState.product.color = defaultCategory.color
    } else if (!product && categories) {
      const cat = categories[0]
      nextState.product.category = cat
      nextState.product.tva = cat.tva
      nextState.product.color = cat.color
    }
    this.updateState(nextState)
  }
  render() {
    const { classes, categories, taxes } = this.props
    const { helpers, isValid, product } = this.state
    const isCreate = !this.props.product
    return (
      <ModalWrapper
        open
        hideModal={this.props.hideModal}
        onOk={isCreate ? this.handleOnCreate : this.handleOnUpdate}
        title={isCreate ? 'Ajouter un produit' : `Editer ${product.name}`}
        okDisabled={!isValid}>
        <Grid
          container
          direction="row"
          alignItems="flex-start"
          justify="space-around">
          <Grid
            container
            direction="row"
            alignItems="center"
            justify="flex-start"
            item
            xs={12}
            sm={12}
            md={6}>
            <Grid item xs={12} sm={12} md={10}>
              <TextField
                id="name"
                helperText={helpers.name || null}
                required
                label="Nom"
                onChange={this.handleChange('name')}
                value={product.name}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={8}>
              <CategorySelectionComponent
                onChange={this.handleCategoryChange}
                categories={categories}
                selectedCategory={product.category}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={8}>
              {this.colorPicker(classes)}
            </Grid>
          </Grid>
          <Grid
            container
            direction="row"
            alignItems="flex-start"
            justify="flex-start"
            item
            xs={12}
            sm={12}
            md={6}>
            <Grid item xs={12} sm={12} md={6}>
              <FormControl fullWidth>
                <InputLabel htmlFor="price">Prix TTC</InputLabel>
                <Input
                  id="price"
                  type="number"
                  value={product.price}
                  onChange={this.handleChange('price')}
                  startAdornment={
                    <InputAdornment position="start">€</InputAdornment>
                  }
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <TaxeSelectionComponent
                onChange={this.handleTvaChange}
                taxes={taxes}
                selectedTaxe={product.tva}
              />
            </Grid>
            <FormControlLabel
              control={
                <Switch
                  disabled
                  checked={product.stockManagement}
                  onChange={this.handleChange('stockManagement')}
                />
              }
              label="Gestion de stock"
            />
          </Grid>
        </Grid>
      </ModalWrapper>
    )
  }
}

export default withStyles(styles)(ProductModal)



// WEBPACK FOOTER //
// ./src/routes/Admin/Products/components/ProductModal.js